// 教育经历
import { Button, Icon } from '@roo/roo';
import React, { useEffect } from 'react';
import P from 'prop-types';
import { get } from 'lodash';
import { Plus } from './Plus';
import { useSimpleContext } from '../_context';

export const FieldList = (props) => {
  const {
    values,
    setFieldValue,
    iniData,
    name,
    itemStyle,
    itemClassName,
    minCount = 1,
    showPlus = true,
  } = props;
  const list = get(values, name) || [];
  const { state } = useSimpleContext((t) => [t.disabled, t.isViewType]);

  useEffect(
    () => {
      const n = props.minCount - list.length;

      if (n > 0) {
        const newItems = new Array(n).fill({ ...iniData });
        // const newList = [...list, ...newItems]
        const newList = list.concat(newItems);
        setFieldValue(name, newList);
      }
    },
    [props.minCount],
  );

  function getChildren(idx = 0) {
    return React.Children.map(props.children, (child) => {
      const subName = child.props?.name || '';
      const key = [name, idx, subName].map(String).filter(Boolean).join('.');

      return React.cloneElement(child, {
        ...child.props,
        name: key,
        idx,
        key,
        values,
        item: get(values, `${name}.${idx}`),
        // prefix: `${name}.${idx}`,
        setFieldValue,
        validateField: props.validateField,
        test: 'test',
      });
    }).filter(Boolean);
  }

  if (props.hid && state.isViewType) {
    return null;
  }
  return (
    <>
      {list.map((item, index) => (
        <div
          className={`${itemClassName} field-list-group`}
          key={index}
          style={{ marginTop: 32, ...itemStyle }}
        >
          {getChildren(index)}
          <br />
          {index >= minCount && list.length > minCount && !state.disabled ? (
            <Button
              type="text"
              className="delete"
              onClick={() => {
                list.splice(index, 1);
                setFieldValue(name, list);
              }}
            >
              <Icon name="trash-o" />
              删除
            </Button>
          ) : null}
        </div>
      ))}
      {showPlus && (
        <Plus
          maxCount={props.maxCount}
          count={list.length}
          text={props.plusText}
          handlePush={() => {
            list.push({ ...iniData });
            setFieldValue(name, list);
          }}
        />
      )}
    </>
  );
};

FieldList.propTypes = {
  iniData: P.object,
  name: P.string,
  maxCount: P.number,
  minCount: P.number,
  plusText: P.string,
  className: P.string,
  itemClassName: P.string,
  style: P.object,
};
